import { lazy, Suspense, useState } from "react";
import { useNavigate } from "react-router-dom";

import FullSizeLoading from "components/FullSizeLoading";
import useFetchNews from "hooks/api/useFetchNews";

const NewsPage = lazy(() => import("pages/News/pc/NewsPage"));

export const NEWS_HEADER_ITEM = {
  CATEGORY: "カテゴリ",
  TITLE: "タイトル",
  RECEIVED_DATE: "受信日",
};

const NewsContainer: React.FC = () => {
  const [pageOption, setPageOption] = useState<CursorPageOption>({
    after: "",
    before: "",
    pageIndex: 1,
  });

  const navigate = useNavigate();
  const { news, pagination, isLoading } = useFetchNews({
    pageSize: 25,
    after: pageOption.after ?? null,
    before: pageOption.before ?? null,
  });

  const handleNavigateNews = (id: string) => {
    navigate(`/news/${id}`);
  };

  return (
    <Suspense fallback={<FullSizeLoading />}>
      <NewsPage
        handleNavigateNews={handleNavigateNews}
        news={news}
        isLoading={isLoading}
        pagination={pagination}
        pageOption={pageOption}
        setPageOption={setPageOption}
      />
    </Suspense>
  );
};

export default NewsContainer;
